// extracted by mini-css-extract-plugin
export default {"badge":"internalTesterBadge_badge__mmpP+","dot":"internalTesterBadge_dot__5k20b"};